function HorizontalCentered({children}) {
  return (
    <div className="flex justify-center items-center">
      {children}
    </div>
  );
}


function VerticalCentered({children}) {
    return (
        <div className="h-screen flex items-center">
            {children}
        </div>
    );
}

function Centered({children}) {
    return (
        <div className="h-screen flex items-center justify-center">
            {children}
        </div>
    );
}

export {HorizontalCentered, VerticalCentered, Centered};